var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_395",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3009 0.5H0.444946V9.494H17.3009V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47295 2.872C8.5792 2.76623 8.72302 2.70686 8.87295 2.70686C9.02287 2.70686 9.16669 2.76623 9.27295 2.872L12.7229 6.32C12.7815 6.37108 12.8289 6.43366 12.8623 6.50384C12.8957 6.57402 12.9143 6.65031 12.9169 6.72798C12.9195 6.80564 12.9062 6.88302 12.8777 6.95532C12.8492 7.02761 12.8061 7.09326 12.7512 7.14821C12.6962 7.20316 12.6306 7.24623 12.5583 7.27474C12.486 7.30325 12.4086 7.3166 12.3309 7.31396C12.2533 7.31131 12.177 7.29273 12.1068 7.25936C12.0366 7.226 11.974 7.17856 11.9229 7.12L9.44295 4.64C9.29048 4.48924 9.08967 4.39716 8.87595 4.38C8.66219 4.39708 8.46136 4.48917 8.30895 4.64L5.82595 7.122C5.71766 7.21646 5.57754 7.26628 5.43393 7.26138C5.29031 7.25649 5.15391 7.19725 5.0523 7.09564C4.95069 6.99403 4.89145 6.85763 4.88656 6.71402C4.88167 6.5704 4.93149 6.43029 5.02595 6.322L8.47295 2.872Z",
    fill: "#144B95",
    stroke: "#144B95",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.d2c306cd161a10065f458e7abb742518.svg";
export { ForwardRef as ReactComponent };